import moment from "moment/moment";

const log = require("loglevel").getLogger("General");
log.setLevel("error");

export const convertExcelToJson = (data) => {
	const headers = data[0];
	const jsonData = data.slice(1).map(row => {
		return headers.reduce((obj, header, index) => {
			obj[header] = row[index];
			return obj;
		}, {});
	});

	return jsonData;
};

export const camelCaseToProperEnglish = (text) => {
	// Insert space before capital letters (except the first letter)
	const spacedText = text.replace(/([a-z])([A-Z])/g, '$1 $2');
	// Capitalize the first letter of each word
	return spacedText.replace(/\b\w/g, char => char.toUpperCase());
};

export const twoDigits = value => {
	if(value != null) {
		if(value.toString().length === 1) {
			value = ("0" + value.toString());
		}
		else if(value.toString().indexOf(".") > -1) {
			const parts = value.toString().split(".");
			if(parts[0].length === 1) {
				parts[0] = ("0" + value.toString());
			}
			value = parts.join("");
		}
	}
	return value;
};

export const formatLargeNumberToMoney= (number) => {
	let label;
	if (number >= 1000000) {
		label = (number / 1000000).toFixed(1) + 'M';
	} else if (number >= 1000) {
		label = (number / 1000).toFixed(0) + 'K';
	} else {
		label = number.toString();
	}

	return '$' + label;
};

export const formatLargeNumber = (number) => {
	if (number >= 1000000) {
		return (number / 1000000).toFixed(1);
	} else if (number >= 1000) {
		return (number / 1000).toFixed(0);
	} else {
		return number.toString();
	}
};

export const getInitials = (fullName) => {
	if (!fullName || !fullName.trim()) return ''; // Handle cases where the name is empty or just spaces

	return fullName
		.split(' ')
		.filter(name => name !== '') // Filter out any empty strings that might result from extra spaces
		.map(name => name.charAt(0).toUpperCase())
		.join('');
};

export const ext = (u) => {
	return u.email.toLowerCase().indexOf(process.env.REACT_APP_INTERNAL_EMAIL_EXTENSION) < 0;
};

// verifies 8 characters with 1 digit, 1 upper and 1 lower
export const isValidPassword = (password) => {
	// Ensure the password is a string
	if (typeof password !== 'string') return false;

	// Use a regular expression to check the requirements
	const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
	return regex.test(password);
};

export const isNullOrEmpty = value => {
	return value == null || value === '';
};

export const arrayLengthOrZero = arr => {
	return arr == null ? 0 : arr.length;
};

export const isTrue = value => {
	return value != null && value === true;
};

export const isNullOrEmptyArray = arr => {
	return arr == null || arr.length === 0;
};

export const isNullOrZero = value => {
	return value == null || value === 0;
};

export const isNullOrFalse = value => {
	return value == null || value === false;
};

export const capitalize = (str) => {
	if(isNullOrEmpty(str)) {
		return "";
	}

	return str.replace(/\b\w/g, function(l) {
		return l.toUpperCase();
	});
};

export const isSameValuesInArrays = (arr1, arr2) => {
	for(let i=0 ; i<arr1.length ; i++) {
		const value = arr1[i];
		const found = arr2.findIndex(item => item === value) > -1;

		if(!found) {
			return false;
		}
	}

	return true;
};

export const getOrdinal = num => {
	const lastDigit = num.toString().substr(-1);

	if(Number(lastDigit) === 1) {
		return `${num}st`;
	}
	else if(Number(lastDigit) === 2) {
		return `${num}nd`;
	}
	else if(Number(lastDigit) === 3) {
		return `${num}rd`;
	}

	return `${num}th`;
};

export const ordinalToInt = ord => {
	const options = [
		{int:1, str:"first", ord:"1st"},
		{int:2, str:"second", ord:"2nd"},
		{int:3, str:"third", ord:"3rd"},
		{int:4, str:"fourth", ord:"4th"},
		{int:5, str:"fifth", ord:"5th"},
		{int:6, str:"sixth", ord:"6th"},
		{int:7, str:"seventh", ord:"7th"},
		{int:8, str:"eighth", ord:"8th"},
		{int:9, str:"ninth", ord:"9th"},
		{int:10, str:"tenth", ord:"10th"},
		{int:11, str:"eleventh", ord:"11th"},
		{int:12, str:"twelfth", ord:"12th"},
		{int:13, str:"thirteenth", ord:"13th"},
		{int:14, str:"fourteenth", ord:"14th"},
		{int:15, str:"fifteenth", ord:"15th"},
		{int:16, str:"sixteenth", ord:"16th"},
		{int:17, str:"seventeenth", ord:"17th"},
		{int:18, str:"eighteenth", ord:"18th"},
		{int:19, str:"nineteenth", ord:"19th"},
		{int:20, str:"twentieth", ord:"20th"}
	];

	return options.find(o => o.str === ord.toLowerCase() || o.ord === ord.toLowerCase());
};

export const mapToObjectArray = map => {
	const arr = [];
	Object.keys(map).forEach(key => {
		const value = map[key];
		const obj = { key, value };
		arr.push(obj);
	});
	return arr;
};

export const applyFilter = (items, filter) => {
	if(filter.type === "list") {
		if(filter.operator.key === "include") {
			items = items.filter(f => filter.value.indexOf(f[filter.key]) > -1);
		}
		else {
			items = items.filter(f => filter.value.indexOf(f[filter.key]) === -1);
		}
	}
	else if(filter.type === "text") {
		if(filter.operator.key === "is_exact") {
			items = items.filter(f => f[filter.key] && filter.value === f[filter.key].toLowerCase());
		}
		else if(filter.operator.key === "contains") {
			items = items.filter(f => f[filter.key] && f[filter.key].toLowerCase().indexOf(filter.value.toLowerCase()) > -1);
		}
		else { // not_contains
			items = items.filter(f => f[filter.key] && f[filter.key].toLowerCase().indexOf(filter.value.toLowerCase()) === -1);
		}
	}
	else if(filter.type === "numeric") {
		if(filter.operator.key === "between") {
			// New range slider format (Filters component): filter.value = { min: number, max: number }
			const min = filter.value.min || 0;
			const max = filter.value.max || Number.MAX_SAFE_INTEGER;
			items = items.filter(f => f[filter.key] && f[filter.key] >= min && f[filter.key] <= max);
		}
		else if(filter.operator.key === "more_than") {
			items = items.filter(f => f[filter.key] && f[filter.key] > filter.value);
		}
		else if(filter.operator.key === "less_than") {
			items = items.filter(f => f[filter.key] && f[filter.key] < filter.value);
		}
		else { // exactly
			items = items.filter(f => f[filter.key] && f[filter.key] === filter.value);
		}
	}
	else if(filter.type === "date") {
		if(filter.operator.key === "before") {
			items = items.filter(f => f[filter.key] && moment(f[filter.key]).isBefore(filter.value));
		}
		else if(filter.operator.key === "after") {
			items = items.filter(f => f[filter.key] && moment(f[filter.key]).isAfter(filter.value));
		}
		else if(filter.operator.key === "after") {
			items = items.filter(f => f[filter.key] && moment(f[filter.key]).isSame(filter.value));
		}
		else {
			const [startDate, endDate] = filter.value.split(' - ').map(date => moment(date, 'DD/MM/YYYY'));

			items = items.filter(item => {
				const itemDate = moment(item[filter.key]);
				return itemDate.isBetween(startDate, endDate, null, '[]');
			});
		}
	}

	return items;
};

export const objectArrayToMap = arr => {
	const map = [];
	arr.map(obj => map[obj.key] = obj.value);
	return map;
};

export const formatDate = date => {
	return moment(date).isValid() ? moment(date).format("YYYY-MM-DD") : date;
};

export const compareValues = (sortData, secondarySortData) => {
	const primaryProps = sortData.name.split(".");
	const primaryLen = primaryProps.length;
	const primaryOrder = sortData.desc === true ? 'desc' : 'asc';

	let secondaryProps;
	let secondaryLen;
	let secondaryOrder;

	if(secondarySortData && sortData.name !== secondarySortData.name) {
		secondaryProps = secondarySortData.name.split(".");
		secondaryLen = secondaryProps.length;
		secondaryOrder = secondarySortData.desc === true ? 'desc' : 'asc';
	}

	return function innerSort(a, b) {
		try {
			let i = 0;
			while( i < primaryLen ) { a = a[primaryProps[i]]; b = b[primaryProps[i]]; i++; }

			let varA, varB;

			if(new Date(a).isValid() && new Date(b).isValid()) {
				varA = new Date(a);
				varB = new Date(b);
			}
			else {
				varA = (typeof a === 'string') ? a.toUpperCase() : a;
				varB = (typeof b === 'string') ? b.toUpperCase() : b;
			}

			let comparison = 0;
			if (varA > varB) {
				comparison = 1;
			}
			else if (varA < varB) {
				comparison = -1;
			}
			// fields are equal, sort by secondary
			else if(secondarySortData) {
				i = 0;
				while( i < secondaryLen ) { a = a[secondaryProps[i]]; b = b[secondaryProps[i]]; i++; }

				if(new Date(a).isValid() && new Date(b).isValid()) {
					varA = new Date(a);
					varB = new Date(b);
				}
				else {
					varA = (typeof a === 'string') ? a.toUpperCase() : a;
					varB = (typeof b === 'string') ? b.toUpperCase() : b;
				}

				if (varA > varB) {
					comparison = 1;
				}
				else if (varA < varB) {
					comparison = -1;
				}

				return (
					(secondaryOrder === 'desc') ? (comparison * -1) : comparison
				);
			}

			return (
				(primaryOrder === 'desc') ? (comparison * -1) : comparison
			);
		}
		catch(e) {
			log.debug("Sorting Error:");
			log.debug(a);
			log.debug(b);
			return 0;
		}
	}
};
export const formatUTCdateWithTime = date => {
	return moment(date).isValid()
		? moment.utc(date).local().format("YYYY-MM-DD HH:mm")
		: date;
};
